import { State } from '../StateTypes';
import { Dialog } from './dialogTypes';

export const selectDialog = ({ dialog }: State): Dialog => dialog;

export const selectDialogExists = ({ dialog }: State): Dialog => dialog.type;
export const selectDialogOptions = ({ dialog }: State): Dialog => dialog.options;